import { inject, Injectable } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { EditTreatmentMessageTemplateDialogComponent } from './edit-treatment-message-template-dialog.component';
import { EditTreatmentMessageTemplateDialogConfig } from './edit-treatment-message-template-dialog-config';

@Injectable()
export class TreatmentMessageTemplateDialogService {
    private readonly _dialogService = inject(DialogService);

    open(data: EditTreatmentMessageTemplateDialogConfig) {
        const { instruction } = data;
        const isNew = instruction.id == null || instruction.id < 1;
        return this._dialogService.open(EditTreatmentMessageTemplateDialogComponent, {
            data,
            resizable: false,
            maximizable: false,
            modal: true,
            width: '70vw',
            header: isNew ? '新增消息模板' : '编辑消息模板',
        });
    }
}
